<script>
    import {numberAsMoney} from '../util/util';

    let projectDatas = [
        {id: 1, title: '세븐틴 버논 & 도겸 생일 축하 전광판 광고 프로젝트', dday: 10, members: 39, targetPrice: 36, targetMember: 25, totalPrice: 2920000, img: 'project-01.jpg', link: '#'},
        {id: 2, title: 'BTS 지민 생일카페 개최 프로젝트', dday: 30, members: 79, targetPrice: 36, targetMember: 25, totalPrice: 2620000, img: 'project-02.jpg', link: '#'},
    ]
</script>

<ul class="projectlist">
    {#each projectDatas as projectData (projectData.id)}
    <li class="projectlist__item">
        <a href={projectData.link} class="projectlist__link">
            <div class="projectlist__title">{projectData.title}</div>
            <div class="projectlist__row">
                <div class="projectlist__thumb"><img src={`./images/${projectData.img}`} alt="" /></div>
                <div class="projectlist__info">
                    <div class="projectlist__user">
                        <div class="projectlist__daymember">D-{projectData.dday}</div>
                        <div class="projectlist__daymember"><img src="./images/project-member.svg" alt="참가자 수" /> {projectData.members}</div>
                    </div>
                    <dl class="projectlist__target projectlist__target--price">
                        <dt>목표 금액</dt>
                        <dd>{projectData.targetPrice}%</dd>
                    </dl>
                    <dl class="projectlist__target projectlist__target--member">
                        <dt>목표 인원</dt>
                        <dd>{projectData.targetMember}%</dd>
                    </dl>
                    <div class="projectlist__total">{numberAsMoney(projectData.totalPrice)}원</div>
                </div>
            </div>
        </a>
    </li>
    {/each}
</ul>

<style>
    .projectlist__item {
        border: 1px solid var(--color-border);
        border-radius: 5px;
        position: relative;
        padding: 10px;
    }
    .projectlist__item + .projectlist__item {
        margin-top: 10px;
    }
    .projectlist__link {
        display: block;
    }
    .projectlist__title {
        font-weight: 700;
        font-size: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border);
    }
    .projectlist__row {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
    }
    .projectlist__thumb {
        width: 150px;
        border-radius: 5px;
        max-height: 150px;
        overflow: hidden;
    }
    .projectlist__info {
        flex: 1;
        margin-left: 10px;
    }
    .projectlist__info {
        flex: 1;
        margin-left: 10px;
    }
    .projectlist__user {
        display: flex;
        border: 1px solid var(--color-border);
        align-items: center;
    }
    .projectlist__daymember {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        padding: 10px 0;
        align-items: center;
    }
    .projectlist__daymember img {
        height: 20px;
        margin-right: 5px;
    }
    .projectlist__target {
        margin-top: 5px;
        border: 1px solid var(--color-border);
        align-items: center;
        display: flex;
        align-items: center;
    }
    .projectlist__target dt {
        padding: 5px;
        width: 80px;
        font-size: 14px;
        background: var(--color-primary);
        text-align: center;
    }
    .projectlist__target dd {
        text-align: right;
        padding: 5px;
        flex: 1;
        font-size: 14px;
    }
    .projectlist__total {
        margin-top: 10px;
        text-align: right;
        font-size: 18px;
        font-weight: 700;
        color: var(--color-secondary);
    }
</style>